import { environment } from '@environments/environment';

export const GET_FRONTS_QUERY = (langcode: string, type_produit: string, category: string, filters?: string[]) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_finitions ?? '',
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              type_produit,
            },
          },
          {
            term: {
              field_facade_category: category,
            },
          },
          ...(filters && filters?.length > 0 ? [{ terms: { field_type_poignee: filters } }] : []),
        ],
      },
    },
    _source: ['title', 'field_images', 'field_handle'],
  },
});
